import type { FormEvent } from 'react'
import React, { useCallback, useState } from 'react'

import { Box } from '@mui/material'
import { useAuthContext } from 'AuthProvider'
import { SearchFrom, SelectCenter, SelectSupplier } from 'components/commonparts'

import type { GetOrderAlertOrderAlertGetRequest, ResponseResult } from 'api-client'

interface SearchConditionProps {
  searchParam: GetOrderAlertOrderAlertGetRequest
  onSearch: (requestParam: GetOrderAlertOrderAlertGetRequest, e: FormEvent<HTMLFormElement>) => void
  result?: ResponseResult | undefined
}

function SearchCondition({ searchParam, onSearch, result }: SearchConditionProps) {
  const { loginUserInfo } = useAuthContext()

  let initialCenterIds: number[] = []
  if (searchParam.centerIds && searchParam.centerIds.length > 0) {
    initialCenterIds = searchParam.centerIds
  }
  let initialOrgSupplierIds: string[] = []
  if (searchParam.orgSupplierIds && searchParam.orgSupplierIds.length > 0) {
    initialOrgSupplierIds = searchParam.orgSupplierIds
  }
  const [centerId, setCenterId] = useState<number | null | undefined>(
    // NOTE:centerIdは必須項目になっていて0を初期値としているため、0の場合はundefinedにする
    searchParam.centerId === 0 ? undefined : searchParam.centerId
  )
  const [centerIds, setCenterIds] = useState<number[]>(initialCenterIds)
  const [orgCenterIdList, setOrgCenterIdList] = useState<string[]>([])
  const [orgSupplierIds, setOrgSupplierIds] = useState<string[]>(initialOrgSupplierIds)
  const noopSetSupplierInfo = useCallback(() => {}, [])
  const noopSetSupplierInfoList = useCallback(() => {}, [])
  const noopSetCenterSupplierInfoList = useCallback(() => {}, [])
  const noopSetCenterInfo = useCallback(() => {}, [])
  const noopSetOrgSupplierId = useCallback(() => {}, [])

  const onClear = () => {
    setCenterId(undefined)
    setCenterIds([])
    setOrgCenterIdList([])
    setOrgSupplierIds([])
  }
  const isSearchDisabled = centerIds.length === 0 && orgSupplierIds.length === 0

  return (
    <Box
      component="form"
      onSubmit={(e) => {
        e.preventDefault()

        // 必須入力チェック
        let selectedCenterIds = centerIds
        if (selectedCenterIds.length === 0 && centerId) {
          selectedCenterIds = [centerId]
        }
        const selectedOrgSupplierIds = orgSupplierIds

        if ((selectedCenterIds.length > 0 || selectedOrgSupplierIds.length > 0)) {
          onSearch(
            {
              centerId: selectedCenterIds.length > 0 ? selectedCenterIds[0] : undefined,
              centerIds: selectedCenterIds,
              orgSupplierIds: selectedOrgSupplierIds,
            },
            e
          )
        }
      }}
    >
      <SearchFrom onClear={onClear} result={result} searchDisabled={isSearchDisabled}>
        <SelectCenter
          trCompanyId={loginUserInfo!.companyId}
          centerId={centerId}
          centerIds={centerIds}
          setCenterId={setCenterId}
          setCenterInfo={noopSetCenterInfo}
          isRequired={false}
          setIsValid={() => {}}
          isMultiple
          setCenterIdList={setCenterIds}
          setOrgCenterIdList={setOrgCenterIdList}
        />
        <SelectSupplier
          trCompanyId={loginUserInfo!.companyId}
          orgSupplierId={undefined}
          orgSupplierIdList={orgSupplierIds}
          setOrgSupplierId={noopSetOrgSupplierId}
          setOrgSupplierIdList={setOrgSupplierIds}
          centerId={centerIds.length === 1 ? centerIds[0] : undefined}
          orgCenterId={orgCenterIdList.length === 1 ? orgCenterIdList[0] : undefined}
          centerIdList={centerIds.length > 1 ? centerIds : undefined}
          orgCenterIdList={orgCenterIdList.length > 1 ? orgCenterIdList : undefined}
          setSupplierInfo={noopSetSupplierInfo}
          setSupplierInfoList={noopSetSupplierInfoList}
          isRequred={false}
          setIsValid={() => {}}
          enabled
          alignmentFlag
          isMultiple
          setCenterSupplierInfoList={noopSetCenterSupplierInfoList}
        />
      </SearchFrom>
    </Box>
  )
}

export default SearchCondition
